@use '../../scss/utility/functions' as utility;

:host {
  /** @prop --size: the width and height of the icon */
  --size: #{utility.wb-pixel-to-rem(24px)};

  // default fill color for shape-1 - let's pray we never get a different color
  /** @prop --shape-1-fill: fill color of .wb-shape-1 */
  --shape-1-fill: #fff;

  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  width: var(--size);
  height: var(--size);
  user-select: none;

  span {
    display: contents;
  }
}

svg,
::slotted(svg) {
  width: 100%;
  height: auto;
  fill: currentColor;
  max-height: 100%;
}

:host([is-rtl][flip-rtl]) svg {
  transform: scale3d(-1, 1, 1);
}

svg .wb-shape-1 {
  fill: var(--shape-1-fill);
}
